/* ------------------------------------------------------------------
   Variant IMAGES instead of names (only for the products listed below)
   Works on the product page and in the quick-view popup.
------------------------------------------------------------------- */
(function () {
  if (window.__variantImagesLoaded) return;
  window.__variantImagesLoaded = true;

  // Add more product handles here if you ever want the same look elsewhere
  var HANDLES = ['vitamin-e-sunscreen-wipes-with-spf-15-protection'];
  var SIZE = 96; // swatch size in px

  var css = [
    'variant-selects.wl-img-variants .product-form__input--pills{display:flex;flex-wrap:wrap;gap:12px;align-items:flex-start}',
    'variant-selects.wl-img-variants .product-form__label-container{flex:0 0 100%;width:100%}',
    'variant-selects.wl-img-variants .product-form__under-container{flex:0 0 100%}',
    'variant-selects.wl-img-variants input[type=radio]+label.wl-swatch{',
    '  box-sizing:border-box;width:' + SIZE + 'px;height:' + SIZE + 'px;min-width:0;padding:4px!important;margin:0!important;',
    '  border:2px solid #d9d4e3!important;border-radius:14px!important;background:#fff!important;',
    '  color:transparent!important;font-size:0!important;line-height:0!important;letter-spacing:0!important;',
    '  display:inline-flex!important;align-items:center;justify-content:center;position:relative;overflow:hidden;',
    '  cursor:pointer;transition:border-color .15s,box-shadow .15s;text-decoration:none!important}',
    'variant-selects.wl-img-variants input[type=radio]+label.wl-swatch::before{display:none!important}',
    'variant-selects.wl-img-variants input[type=radio]+label.wl-swatch img{width:100%;height:100%;object-fit:contain;border-radius:10px;display:block;pointer-events:none}',
    'variant-selects.wl-img-variants input[type=radio]:checked+label.wl-swatch{border-color:#5b2d91!important;box-shadow:0 0 0 3px rgba(91,45,145,.22)}',
    'variant-selects.wl-img-variants input[type=radio]+label.wl-swatch:hover{border-color:#5b2d91!important}',
    'variant-selects.wl-img-variants input[type=radio]:focus-visible+label.wl-swatch{outline:2px solid #5b2d91;outline-offset:3px}',
    'variant-selects.wl-img-variants label.wl-swatch.wl-soldout{opacity:.5}',
    'variant-selects.wl-img-variants label.wl-swatch.wl-soldout::after{content:"";position:absolute;left:0;top:0;right:0;bottom:0;',
    '  background:linear-gradient(to top right,transparent calc(50% - 1px),#444 calc(50% - 1px),#444 calc(50% + 1px),transparent calc(50% + 1px))}',
    '@media (max-width:480px){variant-selects.wl-img-variants input[type=radio]+label.wl-swatch{width:80px;height:80px}}',
    /* the "Product - ..." name line above the pictures: bigger and bolder */
    'variant-selects.wl-img-variants .product-form__label-container{margin-bottom:12px}',
    'variant-selects.wl-img-variants .product-form__label-container label.form__label,',
    'variant-selects.wl-img-variants .product-form__label-container label.form__label span{',
    '  font-size:24px!important;font-weight:700!important;color:#000!important;letter-spacing:0!important;line-height:1.2!important;text-wrap:balance}',
    '@media (max-width:480px){',
    '  variant-selects.wl-img-variants .product-form__label-container label.form__label,',
    '  variant-selects.wl-img-variants .product-form__label-container label.form__label span{font-size:20px!important}}'
  ].join('\n');

  function addStyle() {
    var st = document.getElementById('wl-variant-img-css');
    if (!st) {
      st = document.createElement('style');
      st.id = 'wl-variant-img-css';
      (document.head || document.documentElement).appendChild(st);
    }
    if (st.textContent !== css) st.textContent = css;
  }

  var productCache = {};
  function getVariants(vs, handle) {
    try {
      var s = vs.querySelector('script[type="application/json"]');
      var arr = s && JSON.parse(s.textContent);
      if (arr && arr.length) return Promise.resolve(arr);
    } catch (e) {}
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { return p.variants; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function imgSrc(v) {
    var src = v && v.featured_image && (v.featured_image.src || v.featured_image);
    if (!src || typeof src !== 'string') return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }

  function matchHandle(vs) {
    var path = (vs.getAttribute('data-url') || '').split('?')[0];
    for (var i = 0; i < HANDLES.length; i++) {
      var tail = '/products/' + HANDLES[i];
      if (path === tail || path.slice(-tail.length) === tail) return HANDLES[i];
    }
    return null;
  }

  function apply(vs) {
    var handle = matchHandle(vs);
    if (!handle) return;
    if (vs.classList.contains('wl-img-variants')) addStyle();
    var radios = Array.prototype.slice.call(vs.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;
    var pending = radios.filter(function (r) {
      var l = vs.querySelector('label[for="' + r.id + '"]');
      return l && !l.getAttribute('data-wl-done');
    });
    if (!pending.length) return;

    getVariants(vs, handle).then(function (variants) {
      if (!variants) return;
      var plan = pending.map(function (r) {
        var l = vs.querySelector('label[for="' + r.id + '"]');
        var v = variants.filter(function (x) { return x.option1 === r.value || x.title === r.value; })[0];
        return { r: r, l: l, v: v, src: imgSrc(v) };
      });
      // only switch to images if EVERY option has a picture
      if (plan.some(function (p) { return !p.l || !p.src; })) return;
      addStyle();
      plan.forEach(function (p) {
        var sold = (p.v && p.v.available === false) ||
          getComputedStyle(p.l).textDecorationLine.indexOf('line-through') > -1;
        var img = document.createElement('img');
        img.src = p.src;
        img.alt = p.r.value;
        img.width = SIZE; img.height = SIZE;
        p.l.insertBefore(img, p.l.firstChild);
        p.l.classList.add('wl-swatch');
        if (sold) p.l.classList.add('wl-soldout');
        p.l.setAttribute('title', p.r.value);
        p.l.setAttribute('aria-label', p.r.value);
        p.l.setAttribute('data-wl-done', '1');
      });
      vs.classList.add('wl-img-variants');
    });
  }

  function run() {
    var list = document.querySelectorAll('variant-selects');
    for (var i = 0; i < list.length; i++) apply(list[i]);
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 60); }

  if (document.documentElement) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('pageshow', run);
  run();
})();